import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Typography } from './../../../../../assets/theme/default';
import { Grid } from './../../../../../assets/theme/layout';
import { Page, Wrapper, Paper, Content, Loading, Alert, Button, ButtonsGroup, Toolbar, Data, Currency, Date, Chip } from './../../../../../components/ui';
import { MercadoPagoService } from './../../../../../services';
import { CheckoutStatus } from './../../../../../scenes';
import UtilClientData from './../../../../client/section/data';
import UtilUserData from './../../../../user/section/data';

import API from './../../../../../config/api';
import TEXT from './../../../../../config/text';

class Page__MP_PreferenceDetail extends React.Component {

    constructor(props){
      super(props);
      this.state = {
        loading: false,
        entity: null
      };
    }

    /**
    * @Event
    * @Description: Is invoked immediately after a component is mounted.
    */
    componentDidMount(){
      this._Init();
    }

    /*
    ** @Event
    ** @Description: Init
    */

    _Init = () => {

      const id = this.props.match.params.id;

      /**
      * @Service
      */
      this._Find(id);

    }

    /*
    ** @Service
    ** @Description: FindAll
    */

    _Find = (id) => {

      MercadoPagoService.preferenceById(id).then((response) => {

        this.setState({ loading: true, entity: response });

      }).catch((error) => {

        let message = TEXT.message.error;

        // @Error
        // @Description: Entitad no encontrada
        // if(error.data.code === 'ENTITY_NOT_FOUNDED'){
        //
        //   message = TEXT.message.without_results;
        //
        //   this.props.history.push('/api/mercadopago/checkout');
        //
        // }

        // @Dispatch alert error
        this.props.alertShow({
          open: true,
          severity: 'error',
          message: message
        });

      });

    }

    /*
    ** @Event
    ** @Description: Copy link checkout
    */
    handleLinkToCheckout = () => {
      if(API.mercadopago.env === 'sandbox'){
        return this.state.entity.mercadopago.sandbox_init_point;
      }else{
        return this.state.entity.mercadopago.init_point;
      }
    }

    /*
    ** @Event
    ** @Description: Copy link checkout
    */
    handleCopyCheckout = () => {

      // @Dispatch alert success
      this.props.alertShow({
        open: true,
        severity: 'info',
        message: "El link de pago se copio a tu portapapeles"
      });

    }

    render(){

      const { loading, entity } = this.state;

      return(
        <Page>

          <Wrapper>

            <Toolbar
              title="Mercado Pago"
              subtitle={ loading ? entity.preference.preference_code : '...' }
              dividerMobile
            >
              <ButtonsGroup>

                { loading && (

                  entity.preference.payment_status === 'approved' ? (

                    <Button
                      size="medium"
                      component={ NavLink }
                      to={`/payments/detail/${ entity.preference.payment_id }`}
                      icon="payment"
                    >
                      Pago
                    </Button>

                  ) : (

                    entity.mercadopago && (
                      API.mercadopago.env === 'sandbox' ? (
                        <CopyToClipboard text={ entity.mercadopago.sandbox_init_point } onCopy={ this.handleCopyCheckout }>
                          <Button icon="link" size="medium">
                            Checkout
                          </Button>
                        </CopyToClipboard>
                      ) : (
                        <CopyToClipboard text={ entity.mercadopago.init_point } onCopy={ this.handleCopyCheckout }>
                          <Button icon="link" size="medium">
                            Checkout
                          </Button>
                        </CopyToClipboard>
                      )
                    )

                  )

                )}

                <Button
                  size="medium"
                  component={ NavLink }
                  to="/api/mercadopago/checkout"
                  icon="back"
                >
                  Volver
                </Button>

              </ButtonsGroup>
            </Toolbar>

            <Paper disablePadding>

              { loading ? (

                <React.Fragment>

                  {/* Checkout Status */}
                  <CheckoutStatus status={ entity.preference.payment_status }/>

                  {/* Client Information */}
                  <Content disableMargin disablePadding>
                    { entity.preference.client ? (
                      <UtilClientData
                        client={ entity.preference.client }
                        titlePersonal="Cliente"
                        hideContact
                        hideLocation
                        hideConfiguration
                      />
                    ) : (
                      <Content divider disableMargin>
                        <Alert severity="warning">
                          <strong>Atención</strong>: El cliente no fue encontrado.
                        </Alert>
                      </Content>
                    )}
                  </Content>

                  {/* Client Information */}
                  <Content disableMargin disablePadding>
                    { entity.preference.user ? (
                      <UtilUserData
                        user={ entity.preference.user }
                        titlePersonal="Usuario"
                        hideConfiguration
                      />
                    ) : (
                      <Content divider disableMargin>
                        <Alert severity="warning">
                          <strong>Atención</strong>: El usuario no fue encontrado.
                        </Alert>
                      </Content>
                    )}
                  </Content>

                  {/* Mercadopago Information */}
                  <Content divider disableMargin>

                    {/* Toolbar Payment */}
                    <Toolbar
                      title="Mercado Pago"
                      size="small"
                    />

                    { entity.mercadopago ? (
                      <Grid container spacing={2}>

                        { entity.preference.reference && (
                          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Data
                              label="Referencia"
                              text={ entity.preference.reference }
                          />
                          </Grid>
                        )}

                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                          <Data
                            label="Subtotal"
                            text={ <Currency value={ entity.preference.subtotal }/> }
                          />
                        </Grid>
                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                          <Data
                            label="Descuento"
                            text={ <Currency value={ entity.preference.discount }/> }
                          />
                        </Grid>
                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                          <Data
                            label="Total"
                            text={ <Currency value={ entity.preference.total }/> }
                          />
                        </Grid>
                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                          <Data
                            label="Tipo"
                            text={ entity.preference.type }
                            capitalize
                          />
                        </Grid>
                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                          <Data
                            label="Expira"
                            text={ entity.mercadopago.expires ? 'SI' : 'NO'  }
                          />
                        </Grid>
                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                          <Data
                            label="Fecha"
                            text={ <Date value={ entity.mercadopago.date_created }/> }
                          />
                        </Grid>
                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                          <Data
                            label="Válido desde"
                            text={ entity.mercadopago.expiration_date_from ? <Date value={ entity.mercadopago.expiration_date_from }/> : '-' }
                          />
                        </Grid>
                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                          <Data
                            label="Válido hasta"
                            text={ entity.mercadopago.expiration_date_to ? <Date value={ entity.mercadopago.expiration_date_to }/> : '-' }
                          />
                        </Grid>
                        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}>
                          <Data
                            label="Máximo número de cuotas"
                            text={ entity.mercadopago.payment_methods.installments ? entity.mercadopago.payment_methods.installments : '-' }
                          />
                        </Grid>
                        <Grid item xl={3} lg={3} md={3} sm={4} xs={6}>
                          <Data
                            label="Preferencia de cuotas"
                            text={ entity.mercadopago.payment_methods.default_installments ? entity.mercadopago.payment_methods.default_installments : '-' }
                          />
                        </Grid>
                        <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                          <Data
                            label="Medios de pagos excluidos"
                            text={
                              <ButtonsGroup>
                                { (
                                    entity.mercadopago.payment_methods.excluded_payment_methods.length > 0 &&
                                    entity.mercadopago.payment_methods.excluded_payment_methods[0].id !== ''
                                  ) ? (
                                  entity.mercadopago.payment_methods.excluded_payment_methods.map(payment_method => {
                                    return (
                                      <Chip label={ payment_method.id } color="secondary" key={ payment_method.id }/>
                                    )
                                  })
                                ) : (
                                  <React.Fragment>-</React.Fragment>
                                )}
                              </ButtonsGroup>
                            }
                          />
                        </Grid>
                      </Grid>
                    ) : (
                      <Alert severity="warning">
                        Atención, hubo un error en la búsqueda del checkout en Mercado Pago.
                      </Alert>
                    )}

                  </Content>

                  {/* Footer */}
                  <Content>
                    <Typography variant="h3" align="right">
                      Total <Currency value={ entity.preference.total }/>
                    </Typography>
                  </Content>

                </React.Fragment>

              ) : (

                <Loading/>

              )}

            </Paper>

          </Wrapper>

        </Page>
      )
    }

};

const mapStateToProps = (state) => {
  return {
    session: state.userState
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    alertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Page__MP_PreferenceDetail);
